import { chain } from 'lodash';
import { load } from 'cheerio';
export var extractValuesFromHtml = function (html, mapper) {
    return chain(html)
        .map(function (h) { return load(h); })
        .map(mapper)
        .flatten()
        .uniq()
        .value();
};
//# sourceMappingURL=extract-values-from-html.js.map